import { render, staticRenderFns } from "./WsLoading.vue?vue&type=template&id=0056c9dc&scoped=true"
import script from "./WsLoading.vue?vue&type=script&lang=js"
export * from "./WsLoading.vue?vue&type=script&lang=js"
import style0 from "./WsLoading.vue?vue&type=style&index=0&id=0056c9dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0056c9dc",
  null
  
)

export default component.exports